var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircleInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "circle-info_svg__a",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12m0-14a1 1 0 0 1 1 1v6h2a1 1 0 1 1 0 2H9a1 1 0 1 1 0-2h2v-5H9a1 1 0 1 1 0-2zm-.6-5c.882 0 1.6.718 1.6 1.6s-.718 1.6-1.6 1.6-1.6-.718-1.6-1.6.718-1.6 1.6-1.6"
}))), _use || (_use = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#circle-info_svg__a",
  fill: "#D0D4DA",
  fillRule: "evenodd"
})));
export default SvgCircleInfo;